import {lazyRegister} from '@/Core/lazyRegister';

lazyRegister.factory('StateHelperFactory', [
    '$state',
    function ($state) {
        return {
            /**
             * Tìm tên State (full name) dựa trên link hoặc url
             * @param {string} path - Ví dụ: '/' hoặc '/instoreorder'
             * @returns {string|null} - Tên state (ví dụ: 'main_layout.home')
             */
            getNameByLink: function (path = '/') {
                if (!path.startsWith('/')) {
                    path = '/' + path;
                }
                
                const searchPath = path.toLowerCase();

                const match = $state.get().find(s => {
                    if (!s.link && !s.url) {
                        return false;
                    }

                    const stateLink = (s.link || '').toLowerCase();
                    const stateUrl = (s.url || '').toLowerCase();

                    return stateLink === searchPath || stateUrl === searchPath;
                });

                return match ? match.name : null;
            }

        };
    }
]);
